import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47af0b60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "farming-container" }
const _hoisted_2 = { class: "farming-content" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-farm" }, null, -1))
const _hoisted_5 = { class: "filter-row" }
const _hoisted_6 = {
  key: 0,
  class: "stake-list"
}
const _hoisted_7 = {
  key: 1,
  class: "no-data"
}

import { ref } from 'vue';
import FarmingItem from '@/components/Farms/FarmingItem.vue';
import { tokenFarmPoolList } from '@/configs/farming/token-farm-pool';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const stakeType = ref('stakeForMining');
const stakeStatus = ref('processing');

function statusChange(status: string) {
  stakeStatus.value = status;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createTextVNode(" " + _toDisplayString(_ctx.$t('farmingPageTitle')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_button, {
          class: _normalizeClass(["filter-btn", { 'active': stakeStatus.value === 'processing' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (statusChange('processing')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('processing')), 1)
          ]),
          _: 1
        }, 8, ["class"]),
        _createVNode(_component_el_button, {
          class: _normalizeClass(["filter-btn", { 'active': stakeStatus.value === 'done' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (statusChange('done')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('done')), 1)
          ]),
          _: 1
        }, 8, ["class"])
      ]),
      (stakeStatus.value === 'processing')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tokenFarmPoolList), (farm) => {
              return (_openBlock(), _createBlock(FarmingItem, {
                farm: farm,
                key: farm.index
              }, null, 8, ["farm"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (stakeStatus.value === 'done')
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.$t('nothingDone')), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})